import requestManager from "../components/platformApi/requestManager";

import appHelper from "@util/appHelper";

export default {

    /**
     * @param   {String}    id
     * @param   {Function}  callback
     */
    getRoleInfo : function (id, callback) {
        requestManager.request({
            url : 'portal/v2/distribution/role/get',
            data : {
                id : id
            }
        }, (error, result) => {
            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            callback(result);
        })
    },


    /**
     * @param   {Array}     id
     * @param   {Function}  callback
     */
    calculateAgencyProductPrice : function (ids = [], callback) {
        requestManager.request({
            url : 'portal/v2/distribution/agency/product/calculatePrice',
            data : {
                ids : ids.join(',')
            }
        }, (error, result) => {
            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            callback(result);
        })
    },

    /**
     * @param   {String}    userCode
     * @param   {Array}     id
     * @param   {Function}  callback
     */
    payAgencyProduct : function (userCode = '', ids = [], callback) {
        requestManager.request({
            url : 'portal/v2/distribution/agency/product/pay',
            method : 'post',
            data : {
                userCode : userCode,
                ids : ids.join(',')
            }
        }, (error, result) => {
            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            callback(result);
        })
    },


};
